import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class RacsTesztlapEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.elokeszitettPath = null;
	}

	setup(props) {
		super.setup(props);
		this.elokeszitettPath = props.elokeszitettPath;
		return this;
	}
}

export default RacsTesztlapEditDto;
